<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1">CONTENTS</h1>
<nav epub:type="toc" id="toc">
<ol class="tocol">
<li class="table-of-content">
<a href="#/0_chapter101inversion">CHAPTER 101 - INVERSION</a>
</li>
<li class="table-of-content">
<a href="#/1_chapter102sweep">CHAPTER 102 - SWEEP</a>
</li>
<li class="table-of-content">
<a href="#/2_chapter103willingtoadmitdefeat">CHAPTER 103 - WILLING TO ADMIT DEFEAT</a>
</li>
<li class="table-of-content">
<a href="#/3_chapter104begeneroustoothers">CHAPTER 104 - BE GENEROUS TO OTHERS</a>
</li>
<li class="table-of-content">
<a href="#/4_chapter105proglacialaversion">CHAPTER 105 - PROGLACIAL AVERSION</a>
</li>
<li class="table-of-content">
<a href="#/5_chapter106backhome">CHAPTER 106 - BACK HOME</a>
</li>
<li class="table-of-content">
<a href="#/6_chapter107home">CHAPTER 107 - HOME</a>
</li>
<li class="table-of-content">
<a href="#/7_chapter108shockedtwoelders">CHAPTER 108 - SHOCKED TWO ELDERS</a>
</li>
<li class="table-of-content">
<a href="#/8_chapter109crabgrab">CHAPTER 109 - CRAB GRAB</a>
</li>
<li class="table-of-content">
<a href="#/9_chapter110exposedhand">CHAPTER 110 - EXPOSED HAND</a>
</li>
<li class="table-of-content">
<a href="#/10_chapter111energetic">CHAPTER 111 - ENERGETIC</a>
</li>
<li class="table-of-content">
<span href="#/11_chapter112theoldmanshowedoffhispower" title="Link target outside of Sample">CHAPTER 112 - THE OLD MAN SHOWED OFF HIS POWER</span>
</li>
<li class="table-of-content">
<span href="#/12_chapter113treatment" title="Link target outside of Sample">CHAPTER 113 - TREATMENT</span>
</li>
<li class="table-of-content">
<span href="#/13_chapter114maneatingflower" title="Link target outside of Sample">CHAPTER 114 - MAN-EATING FLOWER</span>
</li>
<li class="table-of-content">
<span href="#/14_chapter115themagnificentemperorqing" title="Link target outside of Sample">CHAPTER 115 - THE MAGNIFICENT EMPEROR QING</span>
</li>
<li class="table-of-content">
<span href="#/15_chapter116spiritgatheringarraydisc" title="Link target outside of Sample">CHAPTER 116 - SPIRIT GATHERING ARRAY DISC</span>
</li>
<li class="table-of-content">
<span href="#/16_chapter117phenomenology" title="Link target outside of Sample">CHAPTER 117 - PHENOMENOLOGY</span>
</li>
<li class="table-of-content">
<span href="#/17_chapter118success" title="Link target outside of Sample">CHAPTER 118 - SUCCESS</span>
</li>
<li class="table-of-content">
<span href="#/18_chapter119gale" title="Link target outside of Sample">CHAPTER 119 - GALE</span>
</li>
<li class="table-of-content">
<span href="#/19_chapter120surprisevillagers" title="Link target outside of Sample">CHAPTER 120 - SURPRISE VILLAGERS</span>
</li>
<li class="table-of-content">
<span href="#/20_chapter121protectionfee" title="Link target outside of Sample">CHAPTER 121 - PROTECTION FEE</span>
</li>
<li class="table-of-content">
<span href="#/21_chapter122inversionofthesituation" title="Link target outside of Sample">CHAPTER 122 - INVERSION OF THE SITUATION</span>
</li>
<li class="table-of-content">
<span href="#/22_chapter123upperheavenrealm" title="Link target outside of Sample">CHAPTER 123 - UPPER HEAVEN REALM</span>
</li>
<li class="table-of-content">
<span href="#/23_chapter124nuwa" title="Link target outside of Sample">CHAPTER 124 - NUWA</span>
</li>
<li class="table-of-content">
<span href="#/24_chapter125puppettechnique" title="Link target outside of Sample">CHAPTER 125 - PUPPET TECHNIQUE</span>
</li>
<li class="table-of-content">
<span href="#/25_chapter126paleogene" title="Link target outside of Sample">CHAPTER 126 - PALEOGENE</span>
</li>
<li class="table-of-content">
<span href="#/26_chapter127conspiracy" title="Link target outside of Sample">CHAPTER 127 - CONSPIRACY</span>
</li>
<li class="table-of-content">
<span href="#/27_chapter128bumpinto" title="Link target outside of Sample">CHAPTER 128 - BUMP INTO</span>
</li>
<li class="table-of-content">
<span href="#/28_chapter129assign" title="Link target outside of Sample">CHAPTER 129 - ASSIGN</span>
</li>
<li class="table-of-content">
<span href="#/29_chapter130ghost" title="Link target outside of Sample">CHAPTER 130 - GHOST?</span>
</li>
<li class="table-of-content">
<span href="#/30_chapter131scarecrowvictory" title="Link target outside of Sample">CHAPTER 131 - SCARECROW VICTORY</span>
</li>
<li class="table-of-content">
<span href="#/31_chapter132opposingmonoculareye" title="Link target outside of Sample">CHAPTER 132 - OPPOSING MONOCULAR EYE</span>
</li>
<li class="table-of-content">
<span href="#/32_chapter133scarecrowweighted" title="Link target outside of Sample">CHAPTER 133 - SCARECROW WEIGHTED</span>
</li>
<li class="table-of-content">
<span href="#/33_chapter134alarm" title="Link target outside of Sample">CHAPTER 134 - ALARM</span>
</li>
<li class="table-of-content">
<span href="#/34_chapter135alarm" title="Link target outside of Sample">CHAPTER 135 - ALARM</span>
</li>
<li class="table-of-content">
<span href="#/35_chapter136thepolicearehere" title="Link target outside of Sample">CHAPTER 136 - THE POLICE ARE HERE</span>
</li>
<li class="table-of-content">
<span href="#/36_chapter137suspect" title="Link target outside of Sample">CHAPTER 137 - SUSPECT</span>
</li>
<li class="table-of-content">
<span href="#/37_chapter138thecluewasbroken" title="Link target outside of Sample">CHAPTER 138 - THE CLUE WAS BROKEN</span>
</li>
<li class="table-of-content">
<span href="#/38_chapter139experts" title="Link target outside of Sample">CHAPTER 139 - EXPERTS</span>
</li>
<li class="table-of-content">
<span href="#/39_chapter140visit" title="Link target outside of Sample">CHAPTER 140 - VISIT</span>
</li>
<li class="table-of-content">
<span href="#/40_chapter141specialtea" title="Link target outside of Sample">CHAPTER 141 - SPECIAL TEA</span>
</li>
<li class="table-of-content">
<span href="#/41_chapter142condition" title="Link target outside of Sample">CHAPTER 142 - CONDITION</span>
</li>
<li class="table-of-content">
<span href="#/42_chapter143spiritualconcentrationarray" title="Link target outside of Sample">CHAPTER 143 - SPIRITUAL CONCENTRATION ARRAY</span>
</li>
<li class="table-of-content">
<span href="#/43_chapter144jade" title="Link target outside of Sample">CHAPTER 144 - JADE</span>
</li>
<li class="table-of-content">
<span href="#/44_chapter145company" title="Link target outside of Sample">CHAPTER 145 - COMPANY</span>
</li>
<li class="table-of-content">
<span href="#/45_chapter146shock" title="Link target outside of Sample">CHAPTER 146 - SHOCK</span>
</li>
<li class="table-of-content">
<span href="#/46_chapter147imparting" title="Link target outside of Sample">CHAPTER 147 - IMPARTING</span>
</li>
<li class="table-of-content">
<span href="#/47_chapter148thief" title="Link target outside of Sample">CHAPTER 148 - THIEF?</span>
</li>
<li class="table-of-content">
<span href="#/48_chapter149seduction" title="Link target outside of Sample">CHAPTER 149 - SEDUCTION</span>
</li>
<li class="table-of-content">
<span href="#/49_chapter150desperatetotaketherisk" title="Link target outside of Sample">CHAPTER 150 - DESPERATE TO TAKE THE RISK</span>
</li>
<li class="table-of-content">
<span href="#/50_chapter151darknightshadow" title="Link target outside of Sample">CHAPTER 151 - DARK NIGHT SHADOW</span>
</li>
<li class="table-of-content">
<span href="#/51_chapter152bandits" title="Link target outside of Sample">CHAPTER 152 - BANDITS</span>
</li>
<li class="table-of-content">
<span href="#/52_chapter153buy" title="Link target outside of Sample">CHAPTER 153 - BUY</span>
</li>
<li class="table-of-content">
<span href="#/53_chapter154cheapapprentice" title="Link target outside of Sample">CHAPTER 154 - CHEAP APPRENTICE?</span>
</li>
<li class="table-of-content">
<span href="#/54_chapter155decisionabove" title="Link target outside of Sample">CHAPTER 155 - DECISION ABOVE</span>
</li>
<li class="table-of-content">
<span href="#/55_chapter156conversation" title="Link target outside of Sample">CHAPTER 156 - CONVERSATION</span>
</li>
<li class="table-of-content">
<span href="#/56_chapter157conspiracy" title="Link target outside of Sample">CHAPTER 157 - CONSPIRACY</span>
</li>
<li class="table-of-content">
<span href="#/57_chapter158vip" title="Link target outside of Sample">CHAPTER 158 - VIP</span>
</li>
<li class="table-of-content">
<span href="#/58_chapter159purpose" title="Link target outside of Sample">CHAPTER 159 - PURPOSE</span>
</li>
<li class="table-of-content">
<span href="#/59_chapter160conspiracyrise" title="Link target outside of Sample">CHAPTER 160 - CONSPIRACY RISE</span>
</li>
<li class="table-of-content">
<span href="#/60_chapter161conspiracy" title="Link target outside of Sample">CHAPTER 161 - CONSPIRACY</span>
</li>
<li class="table-of-content">
<span href="#/61_chapter162experiment" title="Link target outside of Sample">CHAPTER 162 - EXPERIMENT</span>
</li>
<li class="table-of-content">
<span href="#/62_chapter163shockchange" title="Link target outside of Sample">CHAPTER 163 - SHOCK CHANGE</span>
</li>
<li class="table-of-content">
<span href="#/63_chapter164help" title="Link target outside of Sample">CHAPTER 164 - HELP</span>
</li>
<li class="table-of-content">
<span href="#/64_chapter165fantong" title="Link target outside of Sample">CHAPTER 165 - FAN TONG</span>
</li>
<li class="table-of-content">
<span href="#/65_chapter166mastermind" title="Link target outside of Sample">CHAPTER 166 - MASTERMIND?</span>
</li>
<li class="table-of-content">
<span href="#/66_chapter167inversion" title="Link target outside of Sample">CHAPTER 167 - INVERSION</span>
</li>
<li class="table-of-content">
<span href="#/67_chapter168blackhand" title="Link target outside of Sample">CHAPTER 168 - BLACK HAND</span>
</li>
<li class="table-of-content">
<span href="#/68_chapter169pillboy" title="Link target outside of Sample">CHAPTER 169 - PILL BOY</span>
</li>
<li class="table-of-content">
<span href="#/69_chapter170gossipoven" title="Link target outside of Sample">CHAPTER 170 - GOSSIP OVEN</span>
</li>
<li class="table-of-content">
<span href="#/70_chapter171alchemy" title="Link target outside of Sample">CHAPTER 171 - ALCHEMY</span>
</li>
<li class="table-of-content">
<span href="#/71_chapter172darkcooking" title="Link target outside of Sample">CHAPTER 172 - DARK COOKING</span>
</li>
<li class="table-of-content">
<span href="#/72_chapter173cures" title="Link target outside of Sample">CHAPTER 173 - CURES</span>
</li>
<li class="table-of-content">
<span href="#/73_chapter174internaladultery" title="Link target outside of Sample">CHAPTER 174 - INTERNAL ADULTERY</span>
</li>
<li class="table-of-content">
<span href="#/74_chapter175interrogation" title="Link target outside of Sample">CHAPTER 175 - INTERROGATION</span>
</li>
<li class="table-of-content">
<span href="#/75_chapter176capture" title="Link target outside of Sample">CHAPTER 176 - CAPTURE</span>
</li>
<li class="table-of-content">
<span href="#/76_chapter177upperhook" title="Link target outside of Sample">CHAPTER 177 - UPPER HOOK</span>
</li>
<li class="table-of-content">
<span href="#/77_chapter178lufamily" title="Link target outside of Sample">CHAPTER 178 - LU FAMILY</span>
</li>
<li class="table-of-content">
<span href="#/78_chapter179lufamilymeeting" title="Link target outside of Sample">CHAPTER 179 - LU FAMILY MEETING</span>
</li>
<li class="table-of-content">
<span href="#/79_chapter180struggle" title="Link target outside of Sample">CHAPTER 180 - STRUGGLE</span>
</li>
<li class="table-of-content">
<span href="#/80_chapter181awakening" title="Link target outside of Sample">CHAPTER 181 - AWAKENING</span>
</li>
<li class="table-of-content">
<span href="#/81_chapter182homeagain" title="Link target outside of Sample">CHAPTER 182 - HOME AGAIN</span>
</li>
<li class="table-of-content">
<span href="#/82_chapter183zodiacfoetus" title="Link target outside of Sample">CHAPTER 183 - ZODIAC FOETUS</span>
</li>
<li class="table-of-content">
<span href="#/83_chapter184greatvigor" title="Link target outside of Sample">CHAPTER 184 - GREAT VIGOR</span>
</li>
<li class="table-of-content">
<span href="#/84_chapter185alivecapture" title="Link target outside of Sample">CHAPTER 185 - ALIVE CAPTURE</span>
</li>
<li class="table-of-content">
<span href="#/85_chapter186results" title="Link target outside of Sample">CHAPTER 186 - RESULTS</span>
</li>
<li class="table-of-content">
<span href="#/86_chapter187relatives" title="Link target outside of Sample">CHAPTER 187 - RELATIVES</span>
</li>
<li class="table-of-content">
<span href="#/87_chapter188slip" title="Link target outside of Sample">CHAPTER 188 - SLIP</span>
</li>
<li class="table-of-content">
<span href="#/88_chapter189oldpeople" title="Link target outside of Sample">CHAPTER 189 - OLD PEOPLE</span>
</li>
<li class="table-of-content">
<span href="#/89_chapter190gotoschoolearly" title="Link target outside of Sample">CHAPTER 190 - GO TO SCHOOL EARLY</span>
</li>
<li class="table-of-content">
<span href="#/90_chapter191purchase" title="Link target outside of Sample">CHAPTER 191 - PURCHASE</span>
</li>
<li class="table-of-content">
<span href="#/91_chapter192slicedup" title="Link target outside of Sample">CHAPTER 192 - SLICED UP?</span>
</li>
<li class="table-of-content">
<span href="#/92_chapter193collapsed" title="Link target outside of Sample">CHAPTER 193 - COLLAPSED</span>
</li>
<li class="table-of-content">
<span href="#/93_chapter194cultivator" title="Link target outside of Sample">CHAPTER 194 - CULTIVATOR?</span>
</li>
<li class="table-of-content">
<span href="#/94_chapter195unfriendlyapproach" title="Link target outside of Sample">CHAPTER 195 - UNFRIENDLY APPROACH</span>
</li>
<li class="table-of-content">
<span href="#/95_chapter196aggrieved" title="Link target outside of Sample">CHAPTER 196 - AGGRIEVED</span>
</li>
<li class="table-of-content">
<span href="#/96_chapter197bignews" title="Link target outside of Sample">CHAPTER 197 - BIG NEWS</span>
</li>
<li class="table-of-content">
<span href="#/97_chapter198again" title="Link target outside of Sample">CHAPTER 198 - AGAIN?</span>
</li>
<li class="table-of-content">
<span href="#/98_chapter199again" title="Link target outside of Sample">CHAPTER 199 - AGAIN?</span>
</li>
<li class="table-of-content">
<span href="#/99_chapter200swordimmortal" title="Link target outside of Sample">CHAPTER 200 - SWORD IMMORTAL</span>
</li>
<li class="table-of-content">
<span href="#/100_chapter201transformation" title="Link target outside of Sample">CHAPTER 201 - TRANSFORMATION</span>
</li>
<li class="table-of-content">
<span href="#/101_chapter202noinsurance" title="Link target outside of Sample">CHAPTER 202 - NO INSURANCE!</span>
</li>
<li class="table-of-content">
<span href="#/102_chapter203lvdongbin" title="Link target outside of Sample">CHAPTER 203 - LV DONGBIN</span>
</li>
<li class="table-of-content">
<span href="#/103_chapter204swordtest" title="Link target outside of Sample">CHAPTER 204 - SWORD TEST</span>
</li>
<li class="table-of-content">
<span href="#/104_chapter205theswordimmortalsshock" title="Link target outside of Sample">CHAPTER 205 - THE SWORD IMMORTAL'S SHOCK</span>
</li>
<li class="table-of-content">
<span href="#/105_chapter206seclusion" title="Link target outside of Sample">CHAPTER 206 - SECLUSION</span>
</li>
<li class="table-of-content">
<span href="#/106_chapter207strangeludongbin" title="Link target outside of Sample">CHAPTER 207 - STRANGE LÜ DONGBIN</span>
</li>
<li class="table-of-content">
<span href="#/107_chapter208blindwhitesword" title="Link target outside of Sample">CHAPTER 208 - BLIND WHITE SWORD</span>
</li>
<li class="table-of-content">
<span href="#/108_chapter209unabletofight" title="Link target outside of Sample">CHAPTER 209 - UNABLE TO FIGHT?</span>
</li>
<li class="table-of-content">
<span href="#/109_chapter210winning" title="Link target outside of Sample">CHAPTER 210 - WINNING</span>
</li>
<li class="table-of-content">
<span href="#/110_chapter211gotcaughtintheact" title="Link target outside of Sample">CHAPTER 211 - GOT CAUGHT IN THE ACT</span>
</li>
<li class="table-of-content">
<span href="#/111_chapter212returntoheavenrealm" title="Link target outside of Sample">CHAPTER 212 - RETURN TO HEAVEN REALM</span>
</li>
<li class="table-of-content">
<span href="#/112_chapter213gotit" title="Link target outside of Sample">CHAPTER 213 - GOT IT?</span>
</li>
<li class="table-of-content">
<span href="#/113_chapter214secretinformation" title="Link target outside of Sample">CHAPTER 214 - SECRET INFORMATION</span>
</li>
<li class="table-of-content">
<span href="#/114_chapter215ihavenoday" title="Link target outside of Sample">CHAPTER 215 - I HAVE NO DAY</span>
</li>
<li class="table-of-content">
<span href="#/115_chapter216valleys" title="Link target outside of Sample">CHAPTER 216 - VALLEYS</span>
</li>
<li class="table-of-content">
<span href="#/116_chapter217spiritliquid" title="Link target outside of Sample">CHAPTER 217 - SPIRIT LIQUID</span>
</li>
<li class="table-of-content">
<span href="#/117_chapter218qideviation" title="Link target outside of Sample">CHAPTER 218 - QI DEVIATION</span>
</li>
<li class="table-of-content">
<span href="#/118_chapter219dead" title="Link target outside of Sample">CHAPTER 219 - DEAD?</span>
</li>
<li class="table-of-content">
<span href="#/119_chapter220imonmyhoneymoon" title="Link target outside of Sample">CHAPTER 220 - I'M ON MY HONEYMOON</span>
</li>
<li class="table-of-content">
<span href="#/120_chapter221tianchengcup" title="Link target outside of Sample">CHAPTER 221 - TIANCHENG CUP</span>
</li>
<li class="table-of-content">
<span href="#/121_chapter222originalschoolteam" title="Link target outside of Sample">CHAPTER 222 - ORIGINAL SCHOOL TEAM</span>
</li>
<li class="table-of-content">
<span href="#/122_chapter223matchstart" title="Link target outside of Sample">CHAPTER 223 - MATCH START</span>
</li>
<li class="table-of-content">
<span href="#/123_chapter224rolling" title="Link target outside of Sample">CHAPTER 224 - ROLLING</span>
</li>
<li class="table-of-content">
<span href="#/124_chapter225tease" title="Link target outside of Sample">CHAPTER 225 - TEASE</span>
</li>
<li class="table-of-content">
<span href="#/125_chapter226finale" title="Link target outside of Sample">CHAPTER 226 - FINALE</span>
</li>
<li class="table-of-content">
<span href="#/126_chapter227wulang" title="Link target outside of Sample">CHAPTER 227 - WU LANG</span>
</li>
<li class="table-of-content">
<span href="#/127_chapter228enter" title="Link target outside of Sample">CHAPTER 228 - ENTER</span>
</li>
<li class="table-of-content">
<span href="#/128_chapter229extinction" title="Link target outside of Sample">CHAPTER 229 - EXTINCTION</span>
</li>
<li class="table-of-content">
<span href="#/129_chapter230massacre" title="Link target outside of Sample">CHAPTER 230 - MASSACRE</span>
</li>
<li class="table-of-content">
<span href="#/130_chapter231routine" title="Link target outside of Sample">CHAPTER 231 - ROUTINE</span>
</li>
<li class="table-of-content">
<span href="#/131_chapter232finals" title="Link target outside of Sample">CHAPTER 232 - FINALS</span>
</li>
<li class="table-of-content">
<span href="#/132_chapter233conspiracy" title="Link target outside of Sample">CHAPTER 233 - CONSPIRACY</span>
</li>
<li class="table-of-content">
<span href="#/133_chapter234micronucleus" title="Link target outside of Sample">CHAPTER 234 - MICRONUCLEUS</span>
</li>
<li class="table-of-content">
<span href="#/134_chapter235killrace" title="Link target outside of Sample">CHAPTER 235 - KILL RACE</span>
</li>
<li class="table-of-content">
<span href="#/135_chapter236totakethetopspotagrandending" title="Link target outside of Sample">CHAPTER 236 - TO TAKE THE TOP SPOT A GRAND ENDING</span>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?7b6334e9